import { connect } from 'react-redux';
import { hideMobileMenu } from '../../state/actions/mobileMenuActions';

// Components
import MobileMenuCloseButton from './MobileMenuCloseButton';

export default connect(null, { hideMobileMenu })(MobileMenuCloseButton);